module.exports = __webpack_public_path__ + "static/img/bg-hive-header-user.42840ff8.png";